import axios from 'axios';
import get from 'lodash/get';
import toCamelCase from '../utils/camelCase';
import {
  APP_ACTION_GET_PRICING_FAILED,
  APP_ACTION_CARPER_PRICING_ISSUE,
  logNewRelicError
} from '../utils/newRelicActions';

const checkForZeroPricedCskus = (skus, url, path, params) => {

  Object.keys(skus).forEach((topKey) => {
    const topValue = skus[topKey];

    if (topValue?.available === true) {
      Object.keys(topValue).forEach((key) => {
        const value = topValue[key];
        if (value === 0 || value === 0.00) {
          logNewRelicError(APP_ACTION_CARPER_PRICING_ISSUE, path, null, url, { storeId: params.storeId, sku: topKey });
        }
      });

    }
  });

};

export const getPricingFromThd = (params) => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
  const path = 'api/pricing/getThdPricing';
  const url = `${baseUrl}/${path}`;

  return axios.post(url, params)
    .then(({ data }) => {
      checkForZeroPricedCskus(data?.skuResults, url, path, params);
      return toCamelCase(data);
    })
    .catch((error) => {
      logNewRelicError(APP_ACTION_GET_PRICING_FAILED, path, get(error, 'status', 500), url, params);
      throw new Error(`API ERROR in ${path} ===>`, error);
    });
};